import { type IconConfig } from '@littlebird/sdk';

import { Icons } from '@/assets/icons/icons';

import { EntityIconChip } from './entity-icon';
import { IconPicker } from './icon-picker';

interface IconPickerTriggerProps {
  icon: IconConfig | null;
  label: string;
  onChange: (next: IconConfig | null) => void;
  onOpenChange?: (open: boolean) => void;
  onDismissSuggestion?: () => void;
}

export function IconPickerTrigger({
  icon,
  label,
  onChange,
  onOpenChange,
  onDismissSuggestion,
}: IconPickerTriggerProps) {
  return (
    <div className="relative size-10 shrink-0">
      <IconPicker value={icon} onChange={onChange} onOpenChange={onOpenChange}>
        <button
          type="button"
          aria-label={label}
          className="size-10 rounded-lg transition-opacity hover:opacity-80 focus-ring"
        >
          <EntityIconChip icon={icon} size={20} className="size-10" />
        </button>
      </IconPicker>
      {onDismissSuggestion ? (
        <button
          type="button"
          title="Dismiss icon suggestion"
          aria-label="Dismiss icon suggestion"
          className="absolute -right-1 -top-1 flex size-4 items-center justify-center rounded-full border border-border-strong bg-background-subtle text-foreground-muted shadow-sm transition-colors hover:bg-surface-hover hover:text-foreground focus-ring"
          onClick={onDismissSuggestion}
        >
          <Icons.cancel className="size-2.5" />
        </button>
      ) : null}
    </div>
  );
}
